/**
 * Section registry of the station-page template (TASK-699, Figma
 * 8597:41522). Ids double as the DOM ids of the section blocks the
 * `StationNav` tabs scroll to — every id here has a live section on
 * the page ("Nearby" left the registry with its stub, 2026-08-04;
 * returns when its design lands).
 */
export const STATION_NAV_SECTIONS = [
  { id: 'overview', labelKey: 'nav_overview' },
  { id: 'live-arrivals', labelKey: 'nav_live_arrivals' },
  { id: 'timetable', labelKey: 'nav_timetable' },
  { id: 'facilities', labelKey: 'nav_facilities' },
  { id: 'faq', labelKey: 'nav_faq' },
] as const

export type StationNavSectionId = (typeof STATION_NAV_SECTIONS)[number]['id']
